<div class="container">
	<div class="row">
		<div class="col-12">
			<a routerLink="/" class="app-logo logo" title="Specialized Auth"></a>
		</div>
	</div>
</div>
